<template>
  <div>
    <documents-add-edit-modal
      v-if="showDocumentsModal"
      v-model="showDocumentsModal"
      :sidebarItems="sidebarItems"
      :selectedSidebarItemIndex="selectedSidebarItemIndex"
      sidebarTitle="Documents"
      :modalTitle="modalTitle"
      :modalSubtitle="modalSubtitle"
      :reloadSelectedDocument="reloadSelectedDocument"
      :scheduleEventId="scheduleEvent.id"
      :scheduleEventParticipantId="participantId"
      @onModify="onModify"
      @setCurrentFormItem="setCurrentFormItem"
      :disableEffectiveDatePicker="true"
      :documents="documents"
    />
  </div>
</template>

<script>
import moment from "moment";
import DocumentsAddEditModal from "../document_archive/DocumentsAddEditModal";
import documentServer from "../../server/document";

export default {
  name: "GroupSessionNotesAddEditModal",
  components: { DocumentsAddEditModal },
  props: ["scheduleEvent", "initialDocument"],
  data() {
    return {
      sidebarItems: null,
      selectedSidebarItemIndex: 0,
      totalItems: 0,
      showDocumentsModal: false,
      documents: [],
      reloadSelectedDocument: +new Date(),
      participantId: null
    };
  },
  async mounted() {
    const sidebarItems = [];
    const documentIds = [];
    this.scheduleEvent.episodesOfCare.forEach(p => {
      p.linkedDocuments.forEach(d => {
        sidebarItems.push({
          formId: d.form.id,
          documentId: d.document ? d.document.id : null,
          clientId: p.episodeOfCare.patient.id,
          eocId: p.episodeOfCare.id,
          name: d.form.name,
          subtitle: this.formatEocObj(p.episodeOfCare),
          tooltip: d.form.name,
          documentStatus: d.document ? d.document.status : "",
          documentRefNumber: d.document ? d.document.documentRefNumber : null,
          date: d.document ? d.document.createdAt : null,
          patient: this.formatUser(p.episodeOfCare.patient),
          patientData: p.episodeOfCare.patient,
          mrn: p.episodeOfCare.mrnEocn,
          participantId: p.id,
          initialEffectiveDateTime: this.scheduleEvent.startDateTime,
          totalSignature: d.document ? d.document.totalSignatures : null,
          completedSignature: d.document
            ? d.document.completedSignatures
            : null,
          style: {
            fontSize: "13px"
          },
          statusColor: p.scheduleEventStatus.color,
          statusName: p.scheduleEventStatus.name,
          isEnabledInScheduleEventLocation: d.isEnabledInScheduleEventLocation
        });
        if (d.document) {
          documentIds.push(d.document.id);
        }
      });
    });

    this.sidebarItems = sidebarItems;
    this.documents = await documentServer.documentsFromIdsImproved(documentIds);
    this.totalItems = this.sidebarItems.length;
    this.showDocumentsModal = true;
    if (this.scheduleEvent.episodesOfCare.length > 0) {
      this.participantId = this.scheduleEvent.episodesOfCare[0].id;
    }

    if (this.initialDocument) {
      this.selectedSidebarItemIndex = this.sidebarItems.findIndex(
        s =>
          s.formId == this.initialDocument.formId &&
          s.participantId == this.initialDocument.participantId
      );
      this.participantId = this.initialDocument.participantId;
    }
  },
  methods: {
    onModify(params) {
      this.$emit("onModify", params);
    },
    async setCurrentFormItem(params) {
      if (params.prevDocumentId == null) {
        params.prevDocumentStatus = "";
      }
      if (
        params.prevDocumentId != null &&
        this.totalItems == this.sidebarItems.length
      ) {
        this.sidebarItems[this.selectedSidebarItemIndex].documentId =
          params.prevDocumentId;
      }
      if (
        params.prevDocumentStatus != "" &&
        this.totalItems == this.sidebarItems.length
      ) {
        this.sidebarItems[this.selectedSidebarItemIndex].documentStatus =
          params.prevDocumentStatus;
      }
      if (
        params.documentRefNumber &&
        this.totalItems == this.sidebarItems.length
      ) {
        this.sidebarItems[this.selectedSidebarItemIndex].documentRefNumber =
          params.documentRefNumber;
      }

      if (
        params.totalSignatures != "" &&
        this.totalItems == this.sidebarItems.length
      ) {
        this.sidebarItems[this.selectedSidebarItemIndex].totalSignature =
          params.totalSignatures;
      }
      if (
        params.completedSignatures != "" &&
        this.totalItems == this.sidebarItems.length
      ) {
        this.sidebarItems[this.selectedSidebarItemIndex].completedSignature =
          params.completedSignatures;
      }

      this.selectedSidebarItemIndex =
        params.sidebarItemIndex >= this.sidebarItems.length
          ? 0
          : params.sidebarItemIndex;
      this.reloadSelectedDocument = +new Date();
      this.participantId = this.sidebarItems[
        this.selectedSidebarItemIndex
      ].participantId;
      if (this.totalItems != this.sidebarItems.length) {
        this.totalItems = this.sidebarItems.length;
      }
    }
  },
  computed: {
    modalTitle() {
      return "Group Session Notes";
    },
    modalSubtitle() {
      const duration = moment
        .duration(
          moment(this.scheduleEvent.endDateTime).diff(
            moment(this.scheduleEvent.startDateTime)
          )
        )
        .asMinutes();

      return `Group Date & Time: ${this.formatDate(
        this.scheduleEvent.startDateTime
      )} (${Math.round(duration)}min)`;
    }
  }
};
</script>
